import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QrScanLogItemModel, QrScanLogRequestModel } from 'core/models/qr-scan-log.model';
import { ResponseModel } from 'core/models/response.model';
import { ApiBaseService } from './api.base.service';

@Injectable({
    providedIn: 'root',
})
export class ApiQrScanLogService extends ApiBaseService {
    constructor(http: HttpClient) {
        super(http, '/QrScanLog/');
    }

    public getRegister(
        payload: QrScanLogRequestModel,
    ): Observable<ResponseModel<QrScanLogItemModel>> {
        return this.post<ResponseModel<QrScanLogItemModel>>('Register', JSON.stringify(payload));
    }
}
